var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"img"},[_c('ik-image',{attrs:{"width":_vm.width,"path":_vm.path,"transformation":_vm.transformation}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }